import { Environment } from './config';
import { TranslationKeys} from '../widget/i18n';
export type Cultures = 'en' | 'es' | 'fr' | 'de' | 'it' | 'pt' | 'ru' | 'zh' | 'ja' | 'ar' | 'he';

export interface Bet {
  id: string; 
  eventId: string;
  eventName: string;
  marketName: string;
  selectionName: string;
  odds: number;
  date?: string;
  line?: string;
  closed?:boolean;
  suspended?:boolean;
  previouseOdds?: number;
  isDirty?:boolean;
  eventClosed?:boolean;
  eventSuspended?:boolean;
  eventStatus?:TicketEventStatus; //won=2,pending=0,refund=3,lost=1,halfWon=4,halfLoose=5,cashout=6,unkonwn=-1
  lineStatus?:TicketLineStatus;//open=0,
  autoRemoved?:boolean;
  addOnError?:boolean;
  home?:string;
  away?:string;
  eventSeperator?:string;
  fixtureId?: string;
  eventDate?: string;
  totalOdds?: number;
  eventNameTranslation?:string;
  marketNameTranslation?:string;
  selectionNameTranslation?:string;
}

export enum TicketEventStatus {
  Unknown = -1,
  Pending = 0,
  Lost = 1,
  Won = 2,
  Refund = 3,
  Halfwon = 4,
  Halflost = 5,
  Cashout = 6,
}

export enum TicketLineStatus {
  Unknown = -1,
  Pending = 0,
  Lost = 1,
  Won = 2,
  Refund = 3,
  HalfWon = 4,
  // potential typo here
  HalfLoose = 5,
  Cashout = 6,
}

export interface TotalOdd {
  [odd:string]: number;
  eventId: number;
  previouseOdd: number;
}


export interface EventOdd {
  EventId: string;
  Odd: number;
}

export interface Selection {
  BetTypeId: number;
  BetTypeName: string;
  OddKey: string;
  OddPrice: number;
  OddLine: string | null;
  DisplayOrder: number;
  BetTypeNameTranslated: string;
}

export interface GroupedEvent {
  EventId: number;
  Type: number;
  Selections: Selection[];
  Closed:boolean;
  Suspended:boolean;
  EventName: string;
  EventStatus:TicketEventStatus;
  Home:string;
  Away:string;
  Seperator:string;
  FixtureId: string;
  EventDate: string;
  TotalOdds:number;
  EventNameTranslated: string;
}

export interface InternalGroupedEvent {
  EventId: number;
  Type: number;
  Selections: Bet[];
  Closed:boolean;
  Suspended:boolean;
  EventName: string;
  EventStatus: TicketEventStatus;
  Home:string;
  Away:string;
  Seperator:string;
  FixtureId: string;
  EventDate: string;
  TotalOdds:number;
  EventNameTranslated: string;
}

export interface CalaculationSelection {
  BetTypeId: number;
  BetTypeName: string;
  OddKey: string;
  OddPrice: number;
  DisplayOrder:number
}

export interface CalaculationEvent {
  EventId: number;
  CalculationType: number;
  Selections: CalaculationSelection[];
}

export interface CalaculationRequest {
  BetBuilderEvents:CalaculationEvent[]
}

export interface CalaculationResponse {
  
}

export interface BetContextState {
  bets: Bet[];
  totalOdds: TotalOdd[];
  addBets: (bet: Bet[]) => void;
  removeBets: (bet: Bet[]) => void;
  removeEventBets: (eventId: string) => void;
  clearAll: () => void;
  recalculate: (bets:Bet[]) => SelectionsData;
  changeCulture:(culture: Cultures) => void;
  oddsChanged:(bet:Bet)=>void;
  eventSelected: (eventId: string) => void;
  config: WidgetConfig;
  
}

export interface SelectionsData {
  selections: Bet[];
  totalOdds: TotalOdd[];
}

export interface WidgetConfig {
  calculationApiUrl?: string; //optional the url for the service there is also default values on widget side but it depend on the env parmam in order the 
  environment?: Environment; //optional getting configuration based on env
  viewOnly?: boolean;//optional disable or enable the widget
  isEventCanRemoved?: boolean;//optional should be removed dont use it
  culture?:Cultures,//optional
  brandId?:string;//required without this the calculation api wil not work
  showTicketEventStatus?:boolean;//optional only for view mode on my bets 
  showTicketLinessStatus?:boolean;//optional only for view mode on my bets 
  oddsFlashInterval?:number;//optional flashing odds change interval 
  acceptOddsChange?:boolean;//required 
  allowRemoveEvent?:boolean;//optional
  calculationResultBottom?:boolean;//optional only for view mode on my bets 
  showCalculationError?:boolean;
  transaltions?: TranslationKeys;
  showEmptyState?:boolean;
  ignoreCalculationError?:boolean;
}

export interface MountOptions {
  initialBets?: Bet[];
  onChange?: (data: any) => void;
  onBetRemove?: (bets: Bet[]) => void;
  onBetAdded?: (bets: Bet[]) => void;
  onClearAll?: () => void;
  onRecalculate?: () => void;
  onStateChanged?: (state:BetState) => void;
  onCultureChanged?: (culture:Cultures) => void;
  onCultureDisable?: (disable:boolean) => void;
  onError?:(e:any,message:string)=>void;
  onEventRemove?:(eventId:string)=>void;
  onEventSelected?:(eventId:string)=>void;
  config: WidgetConfig;
}

export interface MountConfig extends WidgetConfig {
  debug?: boolean;
}

export interface BetState {
  bets: Bet[];
  totalOdds: TotalOdd[];
  config: WidgetConfig;
}
